export default "__VITE_ASSET__B7wA5bM7__"